import classNames from 'classnames';
import { type PropsWithChildren, type RefObject, forwardRef } from 'react';

const colorClass = {
  primary: 'text-ds-primary-300 bg-ds-natural-100',
  secondary: 'text-ds-secondary-500 bg-ds-secondary-100',
} as const;

type ChipProps = {
  color?: keyof typeof colorClass;
  uppercase?: boolean;
  className?: string;
};

export const Chip = forwardRef(
  (
    {
      color = 'primary',
      uppercase = false,
      className,
      children,
    }: PropsWithChildren<ChipProps>,
    ref
  ) => {
    return (
      <div
        className={classNames(
          'flex align-center rounded-md  text-ds-200 px-1',
          colorClass[color],
          uppercase && 'uppercase',
          className
        )}
        ref={ref as RefObject<HTMLDivElement>}
      >
        {children}
      </div>
    );
  }
);

Chip.displayName = 'Chip';
